import React, { FC, useMemo } from "react";

import { useProvidersCurrentEmployee } from "~/hooks";

import { getMemberNavigationConfig } from "~/config/NavigationConfig";

import { SidebarLink } from "./SidebarLink";

import {
  ApiMembersUnreadNotificationCountsType,
  NavigationItemCompanyType,
} from "~/domains";

type NavItem = {
  label: string;
  href: string;
};

type PropsType = {
  breadCrumbText: string;
  unreadNotification?: ApiMembersUnreadNotificationCountsType;
  navigationItems?: NavigationItemCompanyType[];
};

export const MemberSidebar: FC<PropsType> = ({
  breadCrumbText,
  unreadNotification,
  navigationItems,
}: PropsType) => {
  const { currentEmployee } = useProvidersCurrentEmployee();
  const defaultBusinessSectionId =
    currentEmployee?.businessSections[0]?.id || "";

  // navigationConfigをメモ化
  const navigationConfig = useMemo(
    () => getMemberNavigationConfig(defaultBusinessSectionId),
    [defaultBusinessSectionId],
  );

  // hiddenAtでフィルタリングして表示するナビゲーション項目を取得
  const displayNavs = navigationItems
    ?.filter((item) => item.role === "member" && !item.hiddenAt)
    .sort((a, b) => a.position - b.position);

  const navs: NavItem[] =
    displayNavs?.map((nav) => {
      const navConfig = navigationConfig[nav.name];
      return navConfig?.href
        ? { label: nav.name, href: navConfig.href }
        : { label: "", href: "" };
    }) || [];

  return (
    <>
      {navs.map((nav) => (
        <SidebarLink
          key={nav.label}
          label={nav.label}
          href={nav.href}
          breadCrumbText={breadCrumbText}
          unreadNotification={unreadNotification}
        />
      ))}
    </>
  );
};
